export default "__VITE_ASSET__55328b2c__"